/**
 * Constants
 *
 * ? These should probably be replaced by design tokens
 */

/**
 * ! FIXME align breakpoint names with design system, CL-27142
 */
export const BREAKPOINTS = {
  mobile: 0,
  tablet: 769,
  desktop: 1025
};
// * Font Weights, currently only REGULAR and BOLD are supported in Studio
export const FONT_WEIGHT = {
  LIGHT: '300',
  REGULAR: '400',
  MEDIUM: '500',
  BOLD: '700'
};
export const Z_INDEX_MAP = {
  DROPDOWN: 11000,
  MODAL_OVERLAY: 10000,
  PAGE_HEADER: 600,
  HIGHEST_STACKED_LAYOUT_BLOCK: 500,
  STYLED_BACKGROUND_CONTAINER_FALLBACK: 1,
  STYLED_BACKGROUND_CONTAINER_BACKGROUND_IMAGE: -1,
  STYLED_BACKGROUND_CONTAINER_BACKGROUND_COLOR: -2
};